/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { locale } from '../../common/localization/localizationService';
import ContractorAdmin from '../contractorAdmin';
import Vehicles from '../vehicles';
import Deviations from '../deviations';
import DeviationCategories from '../deviationCategories';
import { IUser } from '../../models';
import UserAdmin from '../userAdmin';
import EventBus from '../../common/EventBus';
import Depots from '../depots';
import Fractions from '../fractions';
import Units from '../units';
import { History } from 'history';
import OrderExclusionsAdmin from '../orderExclusionsAdmin';
import { hasRole } from '../../utils/GeneralUtils';
import { UserRoles } from '../../redux/modules/auth';
import SurveyCreatorPage from '../surveyCreator';
import SurveyTypesPage from '../surveyTypesPage';
import RoutesOverview from '../RouteOverview';

export interface IAdministrationPageProps {
  authentication: IUser;
  history: History;
}

const AdministrationPage: React.FC<IAdministrationPageProps> = ({
  // eslint-disable-next-line react/prop-types
  authentication,
  history,
}) => {
  const params = new URLSearchParams(document.location.search);
  const page = params.get('page');
  let activeTabIndex = 0;
  if (page === 'exclusion-days') {
    activeTabIndex = 6;
  }

  const [activeTab, setActiveTab] = useState(activeTabIndex);
  useEffect(() => {
    EventBus.emit('fullScreenChange', true);

    return () => {
      EventBus.emit('fullScreenChange', false);
    };
  }, []);
  return (
    <div>
      {hasRole(authentication.auth0Roles, []) && (
        <TabStrip
          selected={activeTab}
          onSelect={(e) => setActiveTab(e.selected)}
        >
          <TabStripTab title={locale.general._vehicles}>
            {activeTab === 0 && <Vehicles history={history} />}
          </TabStripTab>
          <TabStripTab title={locale.deviations._deviations}>
            {activeTab === 1 && <Deviations />}
          </TabStripTab>
          <TabStripTab title={locale.deviations._deviationCategory}>
            {activeTab === 2 && <DeviationCategories />}
          </TabStripTab>
          <TabStripTab title={locale.depots._depots}>
            {activeTab === 3 && <Depots />}
          </TabStripTab>
          <TabStripTab title={locale.fractions._fractions}>
            {activeTab === 4 && <Fractions />}
          </TabStripTab>
          <TabStripTab title={locale.units._units}>
            {activeTab === 5 && <Units />}
          </TabStripTab>
          <TabStripTab title={locale.orderExclusions._exclusionDays}>
            {activeTab === 6 && <OrderExclusionsAdmin />}
          </TabStripTab>
          <TabStripTab title={locale.contractors._contractors}>
            {activeTab === 7 && <ContractorAdmin />}
          </TabStripTab>
       
          {hasRole(authentication.auth0Roles, [
            UserRoles.SUPERADMINISTRATOR,
          ]) && (                
          <TabStripTab title={locale.surveyCreator._schemas}>
            {activeTab === 8 && <SurveyCreatorPage />}
          </TabStripTab>
          )}

          {hasRole(authentication.auth0Roles, [
            UserRoles.SUPERADMINISTRATOR,
          ]) && (
          <TabStripTab title={locale.surveyTypesPage._schemaTypes}>
              {activeTab === 9 && <SurveyTypesPage />}
          </TabStripTab>
          )}

          {hasRole(authentication.auth0Roles, [
            UserRoles.SUPERADMINISTRATOR,
          ]) && (
            <TabStripTab title={locale.general._userAdmin}>
              {activeTab === 10 && <UserAdmin />}
            </TabStripTab>
          )}

        </TabStrip>
      )}
    </div>
  );
};

export default AdministrationPage;
